/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { View } from 'react-native';
class WebVideo extends Component {
    render() {
        return <View {...this.props}/>;
    }
}
export default WebVideo;
